<template>
 <div class="headings--h2">
   {{ catalogNumber }}
 </div>
</template>

<script>

 export default {
   name: 'ArtworkCatalogNumber',
   props: {
     catalogNumber: {
       type: String,
       required: true,
     },
   },
 };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/artwork_catalog_number.vue?09ba7678